import { Users } from "lucide-react";
import { useT } from "@/context/ContentContext";

export default function HomeInterlocutor() {
    const t = useT();
    const items = [
        t("home.interlocutor.item1", "Cliente"),
        t("home.interlocutor.item2", "O Homem da Obra"),
        t("home.interlocutor.item3", "Planeamento · Execução · Coordenação · Entrega"),
    ];
    return (
        <section className="py-16 sm:py-24">
            <div className="max-w-[1400px] mx-auto px-3 sm:px-4">
                <div className="bg-[hsl(var(--forest))] rounded-[2rem] p-10 sm:p-16 text-white overflow-hidden">
                    <div className="grid lg:grid-cols-2 gap-10 items-center">
                        <div>
                            <div className="eyebrow-light mb-6"><Users className="w-3.5 h-3.5" /> {t("home.interlocutor.eyebrow", "Coordenação")}</div>
                            <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.02]">
                                {t("home.interlocutor.title", "A sua obra.")}<br />
                                <span className="font-serif-italic text-[hsl(var(--copper))]">{t("home.interlocutor.title_accent", "Um interlocutor")}</span>
                                <span className="text-[hsl(var(--copper))]">.</span>
                            </h2>
                            <p className="text-white/80 text-lg mt-6 leading-relaxed">
                                {t("home.interlocutor.desc", "Uma remodelação pode envolver várias especialidades. Isso não significa que tenha de coordenar várias pessoas. O Homem da Obra assume a organização e a coordenação dos trabalhos. Sabe sempre com quem falar — e quem responde por toda a obra.")}
                            </p>
                        </div>
                        <div className="bg-white/5 border border-white/15 rounded-3xl p-8">
                            <div className="space-y-4 font-mono text-sm">
                                {items.map((label, i, arr) => (
                                    <div key={i}>
                                        <div className={`flex items-center gap-3 ${i === 1 ? "text-[hsl(var(--copper))] font-bold text-base" : "text-white/85"}`}>
                                            <span className="w-2 h-2 rounded-full bg-[hsl(var(--copper))]" />
                                            {label}
                                        </div>
                                        {i < arr.length - 1 && <div className="ml-1 w-px h-4 bg-white/25 my-1" />}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
